module.exports = __webpack_public_path__ + "static/media/15.82d53b70.jpg";